import { MedicationsSection } from "@/features/patient/medications/components/MedicationsView";
import { useMedications } from "@/portals/patient/context/MedicationsContext";
import { PageSpinner } from "@/shared/components/spinner";

export function MedicationsPage() {
  const { medications, isLoading, error } = useMedications();

  if (isLoading) {
    return <PageSpinner className="bg-[#F7F7F7]" />;
  }

  if (error) {
    return (
      <div className="flex min-h-full flex-col items-center justify-center bg-[#F7F7F7] py-24 text-center">
        <p className="text-sm font-semibold text-[#F36F8F]">{error}</p>
      </div>
    );
  }

  return <MedicationsSection medications={medications} />;
}
